export const LIST_SERVICE_CLASSIFICATION_REQUEST = 'LIST_SERVICE_CLASSIFICATION_REQUEST'
export const LIST_SERVICE_CLASSIFICATION_SUCCESS = 'LIST_SERVICE_CLASSIFICATION_SUCCESS'
export const LIST_SERVICE_CLASSIFICATION_FAIL = 'LIST_SERVICE_CLASSIFICATION_FAIL'

export const LIST_SERVICE_CLASSIFICATION_SUMMARY_REQUEST = 'LIST_SERVICE_CLASSIFICATION_SUMMARY_REQUEST'
export const LIST_SERVICE_CLASSIFICATION_SUMMARY_SUCCESS = 'LIST_SERVICE_CLASSIFICATION_SUMMARY_SUCCESS'
export const LIST_SERVICE_CLASSIFICATION_SUMMARY_FAIL = 'LIST_SERVICE_CLASSIFICATION_SUMMARY_FAIL'

export const CREATE_SERVICE_CLASSIFICATION_REQUEST = 'CREATE_SERVICE_CLASSIFICATION_REQUEST'
export const CREATE_SERVICE_CLASSIFICATION_SUCCESS = 'CREATE_SERVICE_CLASSIFICATION_SUCCESS'
export const CREATE_SERVICE_CLASSIFICATION_FAIL = 'CREATE_SERVICE_CLASSIFICATION_FAIL'

export const DETAIL_SERVICE_CLASSIFICATION_REQUEST = 'DETAIL_SERVICE_CLASSIFICATION_REQUEST'
export const DETAIL_SERVICE_CLASSIFICATION_SUCCESS = 'DETAIL_SERVICE_CLASSIFICATION_SUCCESS'
export const DETAIL_SERVICE_CLASSIFICATION_FAIL = 'DETAIL_SERVICE_CLASSIFICATION_FAIL'

export const UPDATE_SERVICE_CLASSIFICATION_REQUEST = 'UPDATE_SERVICE_CLASSIFICATION_REQUEST'
export const UPDATE_SERVICE_CLASSIFICATION_SUCCESS = 'UPDATE_SERVICE_CLASSIFICATION_SUCCESS'
export const UPDATE_SERVICE_CLASSIFICATION_FAIL = 'UPDATE_SERVICE_CLASSIFICATION_FAIL'

export const DELETE_SERVICE_CLASSIFICATION_REQUEST = 'DELETE_SERVICE_CLASSIFICATION_REQUEST'
export const DELETE_SERVICE_CLASSIFICATION_SUCCESS = 'DELETE_SERVICE_CLASSIFICATION_SUCCESS'
export const DELETE_SERVICE_CLASSIFICATION_FAIL = 'DELETE_SERVICE_CLASSIFICATION_FAIL'
